export const endpoints = {
  WORKLOADS: {
    VIEW: '/workload/view',
    UPDATE: '/workload/update',
  },
  USER: {
    CHANGE_POSITION: '/user/position',
  },
}
